(() => {
  if (window.latineoLazyCollectionTabsInitialized) return;
  window.latineoLazyCollectionTabsInitialized = true;

  const loadingTabs = new WeakSet();

  const makeIdsUnique = (item, suffix) => {
    const elements = [item, ...item.querySelectorAll('[id]')];
    const idMap = new Map();

    elements.forEach((element) => {
      if (!element.id) return;
      const originalId = element.id;
      const uniqueId = `${originalId}-${suffix}`;
      idMap.set(originalId, uniqueId);
      element.id = uniqueId;
    });

    item.querySelectorAll('[for], [aria-labelledby], [aria-describedby]').forEach((element) => {
      ['for', 'aria-labelledby', 'aria-describedby'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (!value) return;
        const updated = value
          .split(' ')
          .map((id) => idMap.get(id) || id)
          .join(' ');
        element.setAttribute(attribute, updated);
      });
    });
  };

  const loadTab = async (tab, panel, template) => {
    if (loadingTabs.has(template)) return;
    loadingTabs.add(template);
    tab.setAttribute('aria-busy', 'true');
    panel.setAttribute('aria-busy', 'true');

    try {
      const collectionUrl = template.dataset.latineoLazyCollection;
      const limit = Number.parseInt(template.dataset.latineoLazyLimit, 10) || 8;
      const response = await fetch(collectionUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const sourceItems = [...documentFragment.querySelectorAll('#product-grid > li')].slice(0, limit);
      const targetList = template.content.querySelector('ul');
      const referenceWrapper = tab
        .closest('tabs-component')
        ?.querySelector('.tabs-component-content.--active .product-card-wrapper');
      const referenceCard = referenceWrapper?.querySelector('.card');

      if (!targetList || sourceItems.length === 0) {
        throw new Error('Collection products were not found');
      }

      sourceItems.forEach((sourceItem, index) => {
        const item = document.importNode(sourceItem, true);
        const itemWrapper = item.querySelector('.product-card-wrapper');
        const itemCard = itemWrapper?.querySelector('.card');

        item.className = 'grid__item swiper-slide';
        item.removeAttribute('data-page');
        if (referenceWrapper && itemWrapper) {
          itemWrapper.className = referenceWrapper.className;
          const wrapperStyle = referenceWrapper.getAttribute('style');
          if (wrapperStyle) itemWrapper.setAttribute('style', wrapperStyle);
        }
        if (referenceCard && itemCard) {
          itemCard.className = referenceCard.className;
          const cardStyle = referenceCard.getAttribute('style');
          if (cardStyle) itemCard.setAttribute('style', cardStyle);
        }
        makeIdsUnique(item, `${panel.id}-${index + 1}`);
        targetList.appendChild(item);
      });

      template.dataset.latineoLoaded = 'true';
      tab.removeAttribute('aria-busy');
      panel.removeAttribute('aria-busy');
      loadingTabs.delete(template);
      tab.click();
    } catch (error) {
      window.location.assign(template.dataset.latineoLazyCollection);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const tab = event.target.closest('tabs-component .tabs-component-panel-trigger');
      if (!tab || tab.classList.contains('--active')) return;

      const panelSelector = tab.getAttribute('href');
      if (!panelSelector || !panelSelector.startsWith('#')) return;

      const panel = document.querySelector(panelSelector);
      const template = panel?.querySelector('template[data-latineo-lazy-collection]');
      if (!template || template.dataset.latineoLoaded === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      loadTab(tab, panel, template);
    },
    true
  );
})();
